/* eslint-disable */
export default {
  to: 'A',
  enterNameOrNumber: 'Inserisci nome o numero',
} as const;

// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter name or number"@#@
